// ABOUTME: The React Query hook behind the Jobs page's feed: it waits for the Auth0 token, asks in the app's language,
// ABOUTME: and keys the cache on both and the tab, like every talent query here.
import { useQuery } from 'react-query';
import { getApiLocale } from 'modules/i18n';
import { useAccessToken } from 'utils/auth';
import { feedApi } from './client';
import { USE_FEED_QUERY_KEY } from './constants';
import { Feed, FeedTab } from './types';

/** Not retried: the 404 that says the feed is off for this talent is pro-core's settled answer. */
export const useFeedQuery = (tab: FeedTab, enabled: boolean) => {
  const { token } = useAccessToken();
  const language = getApiLocale();

  return useQuery<Feed>(
    [USE_FEED_QUERY_KEY, token, language, tab],
    () => feedApi.fetchFeed(token!, language, tab),
    { enabled: !!token && enabled, retry: false }
  );
};
